/**
 * packages/@mach33/ui/views/javascripts/head/frame.js — the shell frame's head
 * entry (packages/@mach33/ui/views/htmls/frame.ejs): the frame's values as
 * window.__M33__, and the embed stamp on <html>.
 *
 * Was the frame's two inline <head> scripts (ADR 0082 P3, sr-1), the first
 * with the server's values pasted into its code (rule 10). A head entry,
 * built as one classic script that <head> loads with a blocking <script src>
 * right after the #m33-frame-boot block it reads (ADR 0082 D3): the shell's
 * client (static/shell.js) and the hosts' head scripts read __M33__ as they
 * run, and the stamp lands before first paint. It imports nothing: a
 * package does not reach into lib/ (rule 4).
 *
 * Contents: view
 * Ontology: Code object M33C-0928 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

// ── The frame's values ───────────────────────────────────────────────────
// { apiBase, staticBase, user, skin, build } — the build id is the running
// revision, which the shell's client compares with /m33/version.
try {
  const block = document.getElementById('m33-frame-boot');
  if (!block) throw new Error('no #m33-frame-boot block on this page');
  window.__M33__ = JSON.parse(block.textContent);
} catch (e) {
  console.error('[ui:frame] ' + String(e && e.message).slice(0, 160));
}

// ── Embedded mode ────────────────────────────────────────────────────────
// A page opened in a frame with ?embed=1 (another agent's tab, e.g. Relay in
// Turing's IDE) drops its header and footer; shell.css owns the look. Frames
// only; it survives in-page links.
try {
  if (window.self !== window.top) {
    const k = 'm33-embed';
    const on = /[?&]embed=1(&|$)/.test(location.search);
    if (on) sessionStorage.setItem(k, '1');
    if (on || sessionStorage.getItem(k) === '1') document.documentElement.classList.add(k);
  }
} catch (e) { /* storage refused (sandboxed frame): no stamp, as before */ }
